'use strict'

export const NETSUITE_PAYMENT_STATUS = 'paid_in_full'
export const NETSUITE_DOCUMENT_SOURCE = 'netsuite'
export const NETSUITE_OUTBOUND_KINDS = Object.freeze({
  PG_ORIGIN: 'pg_origin',
  NS_SEND_BACK: 'ns_send_back',
})
